import { useEffect, useState } from "react";
import { track } from "./lib/track.js";

export type Route =
  | { kind: "home" }
  | { kind: "calendar" }
  | { kind: "calendar-grid" }
  | { kind: "open-hares" }
  | { kind: "not-found"; path: string };

function parse(pathname: string): Route {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/" || path === "") return { kind: "home" };
  if (path === "/calendar") return { kind: "calendar" };
  if (path === "/calendar/month") return { kind: "calendar-grid" };
  if (path === "/open-hares") return { kind: "open-hares" };
  return { kind: "not-found", path };
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parse(window.location.pathname));
  useEffect(() => {
    const onPop = () => setRoute(parse(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  // Fire a pageview on initial load and on every SPA route change. Server-
  // side request logs only see the entry HTML hit, not subsequent client-
  // side navigation — this fills that gap.
  useEffect(() => {
    track("pageview");
  }, [route]);
  return route;
}

export function navigate(path: string) {
  if (path === window.location.pathname) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
